"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
exports.__esModule = true;
exports.IV_WAITING_OFFER = exports.WAITING_OFFER = void 0;
exports.WAITING_OFFER = {
    HEADER: 'Hang tight',
    BODY: 'Please keep the app open while we connect to your credit profile.',
    BODY_BOLD: 'This may take a minute'
};
exports.IV_WAITING_OFFER = __assign(__assign({}, exports.WAITING_OFFER), { BODY: 'Please keep the app open while we process your application', BODY_BOLD: 'This may take a few minutes' });
